// import { LoadingData, SectionHeader } from "app/components/form/renderer";
import {
  lettersOrdersApi,
  useGetClinicalTemplatesQuery,
  useGetLettersQuery,
  useSignLetterMutation,
} from "../../services/lettersOrdersService";
import { useMemo, useState } from "react";
import { letterTemplatesCols, orderCols } from "./lettersOrders.data";

import { getBaseUrl, getListItemValFunc, parseResponse } from "../../helper";
import MainPageDialog, { PageDialogContent } from "../../components/dialog";
import { TinyEditor } from "../../components/tinyEditor";
import { useGroupChatContext } from "../../context/groupchatContext";
import { LoadingData, SectionHeader } from "../../components/section";
import { Icon } from "../../helpers/icons";
import { PrintProcedures } from "../../components/PrintProcedure/PrintProcedures";
import FoxitDialog from "../../components/Foxit/FoxitDialog";
import { toast } from "react-toastify";

export const LettersOrders = (props) => {
  const {
    attachedFiles,
    setAttachedFiles,
    letterOrderDialog,
    setLetterOrderDialog,
  } = props;
  const [documentData, setDocumentData] = useState({
    isOpen: false,
    file: null,
  });
  const [openForm, setOpenForm] = useState(false);
  const [openTemplateModal, setOpenTemplateModal] = useState(false);
  const [selectedLetter, setSelectedLetter] = useState(null);
  const [processingItem, setProcessingItem] = useState(null);
  const [editorActions, setEditorActions] = useState("view");
  const [printDialog, setPrintDialog] = useState(false);
  const [showFaxPopup, setShowFaxPopup] = useState({ open: false });
  const { auth: authToken } = JSON.parse(localStorage.getItem("auth"));
  const groupChatContext = useGroupChatContext();
  const { selectedChat } = useMemo(() => ({
    selectedChat: groupChatContext.selectedChat,
  }));

  const { data: lettersData, isLoading: loadingLetters } = useGetLettersQuery({
    pid: selectedChat?.pid,
  });
  const [signLetter, { isLoading: signingLetter }] = useSignLetterMutation();
  const [printItem] =
    lettersOrdersApi.endpoints.getPreviewTemplates.useLazyQuery();

  const getLetterPreview = async (item, preView) => {
    if (!processingItem) {
      const params = {
        id: item.id,
        pid: selectedChat?.pid,
      };
      if (preView) {
        setEditorActions("view");
        params.portal = "provider";
      } else {
        setEditorActions("new");
        params.preview = "letter";
      }

      setProcessingItem(item.id);
      const res = await printItem(params);
      setProcessingItem(null);
      //   console.log("res", res);
      if (res?.data) {
        const { code, data } = parseResponse(res);
        setSelectedLetter(data || null);
        setShowFaxPopup({
          open: true,
          data: { ...data, uuid: data.file_id ? data.file_id : data.id },
        });
      } else {
        setProcessingItem(null);
        setSelectedLetter({
          is_signed: 0,
          template: "",
        });
      }
      setOpenTemplateModal(true);
    }
  };
  const signTemplate = async (letter, is_signed, slug) => {
    let res = await signLetter({
      ...selectedLetter,
      pid: selectedChat?.pid,
      template: letter,
      is_signed:
        is_signed == 0 || is_signed == 1 ? is_signed : selectedLetter.is_signed,
    });

    if (is_signed == 0) {
      res.data = { ...res.data, msg: "Successfully Letter Unsigned" };
    }
    if (slug == "attach_in_msg") {
      if (res?.data?.data?.ClinicalLetters?.uuid) {
        setAttachedFiles((prevAttachment) => {
          const newArray = [
            ...prevAttachment,
            {
              attachment_id: res?.data?.data?.ClinicalLetters?.uuid,
              mime_type: "application/pdf",
              title: res?.data?.data?.ClinicalLetters?.template_name,
            },
          ];
          return newArray;
        });
      }
      setLetterOrderDialog(false);
    }
    
    // notify(res, dispatch);
    setSelectedLetter(null);
    setOpenForm(false);
    setOpenTemplateModal(false);
    if (slug == "preview") {
      let clinicalLetter=res?.data?.data?.ClinicalLetters
      if (clinicalLetter?.uuid){
        setDocumentData({
          isOpen: true,
          file: {
            attachment_id: clinicalLetter?.uuid,
            mime_type: "application/pdf",
            title: clinicalLetter?.template_name,
            entity_id: clinicalLetter?.document_id,
            entity: "document",
          },
        });
      }
    }
  };
  // const editorActions = [
  //     {text: 'Cancel', btnType: 'default', onClick: () => setSelectedLetter(null)},
  //     {text: 'Save', onClick: signTemplate, loading: signingLetter}
  // ]

  const printAction = () => {
    setOpenTemplateModal(false);
    setPrintDialog(!printDialog);
  };
  let api_url = getBaseUrl();
  let fileUrl = `${api_url}/documents/view.json?id=${
    selectedLetter?.document_id
  }&token=${authToken}&tz=${new Date().getTimezoneOffset()}`;

  return (
    <>
      {documentData.isOpen && (
        <FoxitDialog
          setAttachedFiles={setAttachedFiles}
          foxitDialogState={documentData.isOpen}
          setFoxitDialogState={setDocumentData}
          isFromLettersOrders={true}
          file={documentData.file}
          callBackFun={() => {
            setDocumentData({ isOpen: false, file: null });
            setLetterOrderDialog(false);
          }}
        />
      )}
      <div className="pb-14">
        {/* <MainPageHeader /> */}
        <div className="bg-white p-2">
          <div className="text-right mt-1">
            <button
              className="py-1 mb-2 px-2.5 font-normal border border-bgGreen rounded bg-bgGreen text-[14px] text-white hover:bg-primary-hover"
              onClick={() => setOpenForm(true)}
            >
              New Letter/Order
            </button>
          </div>
          <section className="text-left">
              <SectionHeader
                title="Letters/Orders"
                //   content={
                //     <a className="cursor-pointer" onClick={() => setOpenForm(true)}>
                //       New Letter/Order
                //     </a>
                //   }
              />
              <div className="w-[360px] md:w-auto overflow-auto ">
              <div className="table w-full">
                  <div className="font-bold flex  pl-1 py-2 border-l-4 bg-gray-200 border-left-teal-c-100-20 justify-center items-center">
                    {orderCols.map((col) => (
                      <div className={`${col.widthCss || "flex-1"} `}>
                        {col.label}
                      </div>
                    ))}
                    <div className={"flex-1"}>Actions</div>
                    {/* <div className={`flex-none`}></div> */}
                  </div>
                  {loadingLetters && <LoadingData msg="Loading letters ..." />}
                  <div className="alternative-color font-light text-sm">
                    {lettersData?.length
                      ? lettersData?.map((letter) => (
                          <>
                            <div className="p-2 flex gap-2 justify-center items-center border-t border-gray-200">
                              {orderCols.map((col) => (
                                <div
                                  className={`${col.widthCss || "flex-1 break-all"}`}
                                >
                                  {getListItemValFunc(col, letter)}
                                </div>
                              ))}
                              <div className={`flex-1 flex flex-wrap gap-2 min-w-[180px] md:min-w-0`}>
                                <span
                                  className={`text-cyan-600  ${
                                    processingItem
                                      ? "cursor-not-allowed"
                                      : "cursor-pointer"
                                  } hover:text-cyan-800`}
                                  onClick={() => {
                                    getLetterPreview(letter, true);
                                  }}
                                >
                                  <Icon
                                    onClick={() => {
                                      getLetterPreview(letter, true);
                                    }}
                                    type={
                                      processingItem == letter.id
                                        ? "loading-dots"
                                        : "eye"
                                    }
                                  />
                                </span>
                                {letter.is_signed != 0 && (
                                  <>
                                    <span
                                      onClick={() => {
                                        if (!String(letter?.uuid || "").trim()) {
                                          toast.error("Attachment is missing. Please try again.");
                                          return;
                                        }
                                        setAttachedFiles((prevAttachment) => {
                                          const newArray = [
                                            ...prevAttachment,
                                            {
                                              attachment_id: letter?.uuid,
                                              mime_type: "application/pdf",
                                              title: letter?.template_name,
                                            },
                                          ];
                                          return newArray;
                                        });
                                        setLetterOrderDialog(false);
                                      }}
                                      className="bg-cyan-600 p-1 text-white cursor-pointer"
                                      title="Share via Chat"
                                    >
                                      Share
                                    </span>
                                    <span
                                      onClick={() => {
                                        console.log("letter", letter);
                                        setDocumentData({
                                          isOpen: true,
                                          file: {
                                            attachment_id: letter?.uuid,
                                            mime_type: "application/pdf",
                                            title: letter?.template_name,
                                            entity_id: letter?.document_id,
                                            entity: "document",
                                          },
                                        });
                                      }}
                                      className="bg-cyan-600 p-1 text-white cursor-pointer"
                                      title="Sign & Share"
                                    >
                                      Sign & Share
                                    </span>
                                  </>
                                )}
                              </div>
                            </div>
                          </>
                        ))
                      : ""}
                  </div>
                </div>
              </div>
          </section>
        </div>
      </div>

      {/* print and share */}
      {printDialog ? (
        <PrintProcedures
          completeUrl={fileUrl}
          title="Letter/Order Template"
          userUniqueId={{ uuid: selectedLetter?.uuid, title: "document" }}
          // printLink={"/documents/view.json"}
          printData={showFaxPopup?.data}
          setShowPrintShareView={() => {
            setShowFaxPopup({ open: false, data: null });
            setPrintDialog(false);
            setSelectedLetter(null);
          }}
          faxShow={false}
          printLink={"messages/read_attachment?uuid"}
        />
      ) : null}

      {/* Dialogs ==================================================== */}
      {openForm ? (
        <MainPageDialog
          // modalSize=""
          title={"Letter/Order Templates"}
          footer={false}
          onCancelHandler={() => setOpenForm(false)}
          component={
            <div className="overflow-auto text-left">
              <LetterOrderForm
                getLetterPreview={getLetterPreview}
                processingItem={processingItem}
                onCancelHandler={() => {
                  setSelectedLetter(null);
                  setOpenForm(false);
                }}
                closeHandler={() => {
                  setSelectedLetter(null);
                  setOpenForm(false);
                }}
              />
            </div>
          }
        />
      ) : (
        ""
      )}

      {openTemplateModal ? (
        <MainPageDialog
          // modalSize="md"
          title={
            editorActions == "view"
              ? "Letter/Order Template"
              : "Generate Letter"
          }
          footer={false}
          onCancelHandler={() => {
            setOpenTemplateModal(false);
            setSelectedLetter(null);
          }}
          component={
            <TinyEditor
              printAction={printAction}
              readOnly={selectedLetter?.is_signed == 1 ? true : false}
              setSelectedLetter={() => {
                setOpenTemplateModal(false);
                setOpenForm(false);
                setSelectedLetter(null);
              }}
              signTemplate={signTemplate}
              signingLetter={signingLetter}
              defaultTemplate={selectedLetter?.template}
              template_name={selectedLetter?.template_name}
              {...selectedLetter}
            />
          }
        />
      ) : (
        ""
      )}
    </>
  );
};

const LetterOrderForm = ({ getLetterPreview, processingItem }) => {
  const { data: templatesData, isLoading: loadingTemplates } =
    useGetClinicalTemplatesQuery({ is_active: 1 });

  return (
    <>
      <PageDialogContent>
        <div className="font-bold flex gap-2 p-2 border-l-4 bg-gray-200 border-left-teal-c-100-20 justify-center items-center">
          <div className={`min-w-[190px] md:min-w-0 mr-2 flex-1 break-all`}>Name</div>
          {letterTemplatesCols.map((col) => (
            <div className={`${col.widthCss || "flex-1"}`}>{col.label}</div>
          ))}
        </div>
        {loadingTemplates && <LoadingData msg="Loading letters ..." />}
        <div className="alternative-color">
          {templatesData?.length
            ? templatesData?.map((temp) => (
                <>
                  <div className="p-2 flex gap-2 border-t border-gray-200">
                    <div className={`flex-1`}>
                      <span
                        className={`text-cyan-600 ${
                          processingItem
                            ? "cursor-not-allowed"
                            : "cursor-pointer"
                        } hover:text-cyan-800`}
                        onClick={() => getLetterPreview(temp)}
                      >
                        {temp.template_name}{" "}
                        {processingItem == temp.id ? (
                          <Icon className="ml-1" type="loading-dots" />
                        ) : (
                          ""
                        )}
                      </span>
                    </div>
                    {letterTemplatesCols.map((col) => (
                      <div className={`${col.widthCss || "flex-1"}`}>
                        {getListItemValFunc(col, temp)}
                      </div>
                    ))}
                  </div>
                </>
              ))
            : ""}
        </div>
      </PageDialogContent>
    </>
  );
};
